// Blue pill button with a white icon bubble and a light sweep on hover (Contact, Resume).
// iconMotion: 'turn' tilts an arrow toward "go"; 'drop' nudges a download icon down.
export default function BrandButton({ children, icon, size = 'lg', iconMotion = 'turn', className = '', ...rest }) {
  const lg = size === 'lg'
  const motion = iconMotion === 'drop' ? '[&>svg]:transition-transform [&>svg]:duration-500 group-hover:[&>svg]:translate-y-0.5' : 'group-hover:rotate-[-45deg]'
  return (
    <a
      className={`group relative inline-flex items-center overflow-hidden rounded-full bg-brand text-white transition-transform duration-300 ease-out hover:scale-[1.15] shadow-[0_10px_40px_-8px_rgba(45,92,255,0.8),inset_0_1px_0_rgba(255,255,255,0.4)] ${
        lg ? 'h-14 gap-3 pl-6 pr-2' : 'h-10 gap-2.5 pl-4 pr-1 text-sm'
      } ${className}`}
      {...rest}
    >
      <span className="pointer-events-none absolute inset-y-0 -left-1/2 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/45 to-transparent transition-transform duration-700 group-hover:translate-x-[480%]" />
      <span className="relative">{children}</span>
      <span
        className={`relative grid place-items-center rounded-full bg-white text-[#2D5CFF] transition-transform duration-500 ${motion} ${
          lg ? 'h-10 w-10' : 'h-8 w-8'
        }`}
      >
        {icon}
      </span>
    </a>
  )
}

export function ArrowIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden {...props}>
      <path d="M5 12h14m-6-6 6 6-6 6" />
    </svg>
  )
}
